import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import * as ExcelJS from 'exceljs';
import * as FileSaver from 'file-saver';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { RealtorProfileService } from '../realtor-profile.service';
import { RealtorProfile } from '../realtor-profile';
import { RealtorProfileComponent } from '../realtor-profile/realtor-profile.component';
import { TagAddModalComponent } from '@app/_components/task/tag/tag-add-modal/tag-add-modal.component';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-realtor-profile-list',
    templateUrl: './realtor-profile-list.component.html',
    styleUrls: ['./realtor-profile-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class RealtorProfileListComponent implements OnInit {
	tagType: number;
	realtorListingStatus: any[];
	realtorAdrIsland: any[];
	realtorAdrState: any[];
	realtorProfileTags: any;
	currentSearchForm: any;
	realtorProfileSubjAdrStateList: any;
	realtorProfileSubAdrIslandList: any;
	realtorProfileSelection: any[];
	listingStatuses: { name: string; value: string; }[];
	showRowSelectionValidation: boolean;
	showTagValidation: boolean;
	constructor(
		private realtorProfileService: RealtorProfileService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
		public formBuilder: UntypedFormBuilder,
	) {
		this.statuses = realtorProfileService.statuses
		this.listingStatuses = realtorProfileService.listingStatuses
	}
	tagAddModalDialogRef: MatDialogRef<TagAddModalComponent>;
	// data
	@Input() showFilter = true;
	@Input() showPagination = true;

	realtorProfiles: any;
	realtorProfile: RealtorProfile;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;
	//addressTypes: any;
	form1: UntypedFormGroup;
	exportToExcelLoading = false;
	formToSubmit: any;
	columns: any[] = [
		{ field: 'realtorProfileId', header: 'Id', width: 'auto' },
		{ field: 'firstName', header: 'First Name', width: 'auto' },
		{ field: 'lastName', header: 'Last Name', width: 'auto' },
		{ field: 'emailAddress', header: 'Email Address', width: 'auto' },
		{ field: 'mobilePhone', header: 'Mobile Phone', width: 'auto' },
		{ field: 'adrCompanyName', header: 'Company Name', width: 'auto' },
		{ field: 'listingStatus', header: 'Status', width: 'auto' },
		{ field: 'adrState', header: 'State', width: 'auto' },
		{ field: 'adrIsland', header: 'Island', width: 'auto' },
	];
	getFilteredTags(tags) {
		//if filter text input is empty then load all records
		if (tags == '0') {
			delete this.lazyLoadEvent.filters.guestProfileId;
			this.loadLazy(this.lazyLoadEvent);
		} else {
			//If records found then show filtered records
			if (tags.length > 0) {
				//if filter text input is not empty then load filtered records only
				var filteredIds = [];
				tags.forEach(tag => {
					filteredIds.push(tag.tagSourceId);
				});
				let activityProviderIdFilter = { 'guestProfileId': { 'value': filteredIds, 'matchMode': 'in' } };
				Object.assign(this.lazyLoadEvent.filters, activityProviderIdFilter);
				this.loadLazy(this.lazyLoadEvent);
			} else {
				//Display empty table as no record found with filtered input
				this.realtorProfiles = [];
			}
		}
	}
	ngOnInit(): void {
		try {
			this.fetchFilters();
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.realtorProfileId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}
	formBuild() {

		this.form1 = this.formBuilder.group({

			realtorProfileTags: [],
			realtorListingStatus: [],
			realtorAdrIsland: [],
			realtorAdrState: [],

		});
	}

	onSearchSubmit(searchForm: any) {
		this.showRowSelectionValidation = false;
		this.showTagValidation = false;
		if (searchForm.realtorProfileTags !== undefined && searchForm.realtorProfileTags.length > 0) {
			if (this.realtorProfileSelection !== undefined && this.realtorProfileSelection.length > 0) {
				searchForm.applyTagIds = [];
				this.realtorProfileSelection.forEach(data => {
					searchForm.applyTagIds.push(data.realtorProfileId);
				});
				this.currentSearchForm = searchForm;
				if (searchForm.tagAction == 'add') {
					this.applyTags(searchForm, []);
				} else {
					this.removeApplyTags(searchForm, []);
				}

			} else {
				this.showRowSelectionValidation = true;
			}
		} else {
			this.showTagValidation = true;
		}
	}
	applyTags(searchForm, selectedPropertyCodes: any) {
		try {
			this.realtorProfileService.applyTags(searchForm)
				.subscribe(
					data => {
						console.log('tags are: ' + JSON.stringify(data));
						this.loadLazy(this.lazyLoadEvent);
					},
					error => {
						console.log('tags error are: ' + error);
					},
					() => { }
				);

		} catch (error) {
			this.alertService.error(error);
		}
	}
	removeApplyTags(searchForm, selectedPropertyCodes: any) {
		try {
			this.realtorProfileService.removeApplyTags(searchForm)
				.subscribe(
					data => {
						console.log('tags are: ' + JSON.stringify(data));
						this.loadLazy(this.lazyLoadEvent);
					},
					error => {
						console.log('tags error are: ' + error);
					},
					() => { }
				);

		} catch (error) {
			this.alertService.error(error);
		}
	}
	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-realtorProfile-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.realtorProfileService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.realtorProfiles = res.data.realtorProfiles;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.realtorProfiles = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(realtorProfile: RealtorProfile) {
		try {
			this.formLoading = true;
			this.realtorProfileService.update(realtorProfile)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.realtorProfiles.map((realtorProfile, i) => {
							if (realtorProfile.realtorProfileId === res.data.realtorProfile.realtorProfileId) {
								this.realtorProfiles[i] = res.data.realtorProfile;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(realtorProfile: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(realtorProfile));

			this.formLoading = true;
			this.realtorProfileService.delete(realtorProfile.realtorProfileId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.realtorProfiles.splice(this.realtorProfiles.indexOf(realtorProfile), 1);
						this.recordTotal = this.realtorProfiles.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'RealtorProfile ' + realtorProfile.realtorProfileId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'RealtorProfile ' + realtorProfile.realtorProfileId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "80vw";
			dialogConfig.width = "70vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add RealtorProfile'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(RealtorProfileComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAddRealtor.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addRealtorProfileCB(data);

				// close the dialogBox
				//	dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(realtorProfile: RealtorProfile) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "80vw";
			dialogConfig.width = "70vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			realtorProfile: realtorProfile,
			title: 'Edit RealtorProfile'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(RealtorProfileComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateRealtorProfileCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteRealtorProfileCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addRealtorProfileCB(realtorProfile: RealtorProfile) {
		console.log('Adding RealtorProfile: ' + JSON.stringify(realtorProfile));
		// if we don't have a realtorProfiles array yet...
		if (!this.realtorProfiles) {
			this.realtorProfiles = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.realtorProfiles.unshift(realtorProfile);

		// no idea what this is but it is required to update the array
		this.realtorProfiles = [...this.realtorProfiles];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'RealtorProfile ' + realtorProfile.realtorProfileId + ' Added', life: 3000 });
	}

	updateRealtorProfileCB(realtorProfile: RealtorProfile) {
		console.log('Updating RealtorProfile: ' + JSON.stringify(realtorProfile));
		let itemIndex = this.realtorProfiles.findIndex((item: any) => item.realtorProfileId === realtorProfile.realtorProfileId);
		this.realtorProfiles[itemIndex] = realtorProfile;

		// no idea what this is but it is required to update the array
		this.realtorProfiles = [...this.realtorProfiles];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'RealtorProfile ' + realtorProfile.realtorProfileId + ' Updated', life: 3000 });
	}

	deleteRealtorProfileCB(realtorProfile: RealtorProfile) {
		console.log('Removing RealtorProfile: ' + realtorProfile);
		this.realtorProfiles.splice(this.realtorProfiles.indexOf(realtorProfile), 1);
		this.recordTotal = this.realtorProfiles.length;

		// no idea what this is but it is required to update the array
		this.realtorProfiles = [...this.realtorProfiles];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'RealtorProfile ' + realtorProfile.realtorProfileId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.realtorProfiles ? this.first === (this.realtorProfiles.length - this.rows) : true; }
	isFirstPage(): boolean { return this.realtorProfiles ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(realtorProfile: any) {
		if (realtorProfile?.status) {
			const status = this.statuses.find((e: any) => e.value == realtorProfile.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	exportToExcel(): void {
		if (this.exportToExcelLoading) {
			return;
		}
		this.exportToExcelLoading = true;
		setTimeout(() => {
			this.runExportToExcel();
		}, 0);
	}

	private runExportToExcel(): void {
		const total = this.recordTotal || 0;
		const rowsToFetch = total > 0 ? Math.min(total, 50000) : 10000;
		let multiSort = this.lazyLoadEvent?.multiSortMeta ? [...this.lazyLoadEvent.multiSortMeta] : [];
		if (!multiSort.length) {
			multiSort = [{ field: 'createDate', order: -1 }];
		}
		const event: LazyLoadEvent = {
			first: 0,
			rows: rowsToFetch,
			filters: this.lazyLoadEvent?.filters ? { ...this.lazyLoadEvent.filters } : {},
			multiSortMeta: multiSort,
			sortField: this.lazyLoadEvent?.sortField,
			sortOrder: this.lazyLoadEvent?.sortOrder,
			globalFilter: this.lazyLoadEvent?.globalFilter
		};
		const pageNumber = 0;
		this.realtorProfileService.findByFilter(
			pageNumber,
			event.rows,
			event.sortField,
			event.sortOrder,
			event.multiSortMeta,
			event.globalFilter,
			event.filters
		).pipe(first()).subscribe({
			next: (res: any) => {
				const list = res?.data?.realtorProfiles || [];
				this.buildAndDownloadExcel(list);
				this.messageService.add({
					severity: 'success',
					summary: 'Export Complete',
					detail: `Exported ${list.length} realtor profile(s) to Excel`,
					life: 3000
				});
			},
			error: (err) => {
				console.error('Export failed:', err);
				this.messageService.add({
					severity: 'error',
					summary: 'Export Failed',
					detail: err?.message || 'Failed to export realtor profiles',
					life: 5000
				});
			},
			complete: () => {
				this.exportToExcelLoading = false;
			}
		});
	}

	private buildAndDownloadExcel(profiles: any[]): void {
		const workbook = new ExcelJS.Workbook();
		const sheet = workbook.addWorksheet('Realtor Profiles', { views: [{ state: 'frozen', ySplit: 1 }] });

		const headers = [
			'Id', 'First Name', 'Last Name', 'Email Address', 'Mobile Phone',
			'Company Name', 'Status', 'State', 'Island'
		];
		const headerRow = sheet.addRow(headers);
		headerRow.font = { bold: true };
		headerRow.height = 22;
		headerRow.alignment = { horizontal: 'center', vertical: 'middle' };

		profiles.forEach((p) => {
			sheet.addRow([
				p.realtorProfileId ?? '',
				p.firstName ?? '',
				p.lastName ?? '',
				p.emailAddress ?? '',
				p.mobilePhone ?? '',
				p.adrCompanyName ?? '',
				p.listingStatus ?? '',
				p.adrState ?? '',
				p.adrIsland ?? ''
			]);
		});

		sheet.columns.forEach((col, i) => {
			col.width = 15;
		});

		workbook.xlsx.writeBuffer().then((buffer) => {
			const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
			FileSaver.saveAs(blob, `RealtorProfiles_${new Date().toISOString().slice(0, 10)}.xlsx`);
		});
	}

	showPaginator() {
		return true;
	}
	fetchFilters() {
		try {
			this.realtorProfileService.getFilterData()
				.subscribe(
					res => {
						this.realtorProfileSubjAdrStateList = res.data.filterData.addressStates;
						this.realtorProfileSubAdrIslandList = res.data.filterData.addressIslands;

					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}
}
